import "animate.css";
import React from "react";
import styled from "styled-components";
import { useInView } from "react-intersection-observer";

const CorePillars = () => {
    const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.0 });

    return (
        <Wrapper  ref={ref}
        className={`container ${inView ? "animate__animated animate__slideInLeft" : "opacity-0"}`}>
            <Section>
                <Title className="font40 extraBold animated-gradient-text">Our Core Pillars</Title>
                <PillarsGrid>
                    <Pillar>
                        <Icon>🚀</Icon>
                        <PillarTitle className="animated-gradient-text">Software Services</PillarTitle>
                        <PillarText className="font13">
                            Building scalable, tech-driven solutions that power businesses to new heights.
                        </PillarText>
                    </Pillar>
                    <Pillar>
                        <Icon>📈</Icon>
                        <PillarTitle className="animated-gradient-text">Venture Capital</PillarTitle>
                        <PillarText className="font13">
                            Investing in visionary ideas with long-term growth and exponential potential.
                        </PillarText>
                    </Pillar>
                    <Pillar>
                        <Icon>🔬</Icon>
                        <PillarTitle className="animated-gradient-text">Product Innovation</PillarTitle>
                        <PillarText className="font13">
                            Designing timeless products that blend creativity with technological advancement.
                        </PillarText>
                    </Pillar>
                    <Pillar>
                        <Icon>🎓</Icon>
                        <PillarTitle className="animated-gradient-text">Education & Learning</PillarTitle>
                        <PillarText className="font13">
                            Fostering lifelong learning with tools that expand knowledge beyond boundaries.
                        </PillarText>
                    </Pillar>
                </PillarsGrid>
            </Section>


        </Wrapper>
    );
};

export default CorePillars;

const Wrapper = styled.div`
  max-width: 1200px;
  margin: auto;
  padding: 60px 20px;
`;

const Section = styled.div`
  margin-bottom: 50px;
`;

const Title = styled.h2`
  text-align: left;
  margin-bottom: 20px;
`;

const PillarsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
`;

const Pillar = styled.div`
  padding: 20px;
  border-radius: 10px;
  text-align: left;
`;

const Icon = styled.div`
  font-size: 28px;
  margin-bottom: 10px;
`;

const PillarTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 10px;
`;

const PillarText = styled.p`
`;

const List = styled.ul`
  list-style: none;
  padding: 0;
`;

const ListItem = styled.li`
  font-size: 16px;
  margin-bottom: 10px;
`;

const FooterText = styled.p`
  margin-top: 20px;
  font-size: 14px;
  color: #777;
`;
